module.exports = __webpack_public_path__ + "e6a4a9f9fa3a255302333cb2cd279961.jpg";